<template>
    <!--<div style="margin: 10px">-->
        <v-card tile style="margin: 10px">
            <v-layout row style="padding: 10px">
                <v-flex shrink>
                    <v-icon :color="color" size="64">{{mIcon}}</v-icon>
                </v-flex>
                <v-layout wrap>
                    <v-flex xs12 mr-2 mt-2 class="text-xs-right" style="color: grey; font-size: 16px"><span>{{name}}</span></v-flex>
                    <v-flex xs12 mr-2 mb-2 class="text-xs-right" style="color: #484848; font-size: 18px"><span>{{getMValue()}}</span></v-flex>
                </v-layout>

            </v-layout>
            <!--<p><v-divider style="height: 4px; padding: 0.2px; margin-left: 16px" color="white"></v-divider></p>-->



            <!--<v-card-title primary-title><span style="margin-top: -10px; margin-bottom: -15px">{{name}}</span></v-card-title>-->
            <!--<p><v-divider style="height: 4px; padding: 0.2px; margin-left: 16px" color="white"></v-divider></p>-->
            <!--<v-card-text style="font-weight: bold; font-size: 16px; margin-top: -25px; text-align: right"><span style="margin-bottom: -10px">{{getMValue()}}</span></v-card-text>-->
        </v-card>
    <!--</div>-->
</template>

<script>
import { pad } from 'lodash';

    export default {
        name: "ReportBox",

        props: ['mIcon', 'name', 'mValue', 'color', 'mValueSuffix', 'padding'],

        methods: {
            getMValue(){
                let suffix = this.mValueSuffix ? ' '+this.mValueSuffix : '';
                return this.mValue+suffix;

            }
        }
    }
</script>

<style scoped>
</style>